import { HelpContent } from "../../../../application/domain/help/help-entity";
import {
  SearchFilter,
  SearchFilterProps,
} from "../search-filter/search-filter";
import "./search-results.scss";
import { useExtractContext } from "../../../pages/help/use-search";
import { useSearchResultsController } from "./use-search-results-controller";
import { InlineSpinner } from "@graffer-inc/console-design-kit";

type HighlightSearchResultProps = {
  searchText: string;
  query: string;
};

type SearchResultsProps = {
  query: string;
  contentsList: HelpContent[];
  isLoading: boolean;
} & Omit<SearchFilterProps, "tagList" | "productList">;

const HighlightSearchResult = ({
  searchText,
  query,
}: HighlightSearchResultProps) => {
  const queries = query.split(" ");
  const parts = searchText.split(new RegExp(`(${queries.join("|")})`, "gi"));

  return (
    <span>
      {parts.map((part, index) =>
        queries.some((query) => new RegExp(`(${query})`, "gi").test(part)) ? (
          <span key={index} className="search-result-highlight">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </span>
  );
};

const SearchResultItem: React.FC<{
  content: HelpContent;
  query: string;
}> = ({ content, query }) => {
  const extractContext = useExtractContext();

  return (
    <li key={content.id} className="search-results-item">
      <a className="search-result-link" href={`/help/contents/${content.slug}`}>
        <span className="search-result-product">
          {content.metadata.product?.title}
        </span>
        <span className="search-result-title">
          <HighlightSearchResult searchText={content?.title} query={query} />
        </span>
        <span className="search-result-content">
          <HighlightSearchResult
            searchText={extractContext(query, content.metadata.content) ?? ""}
            query={query}
          />
        </span>
        <span className="search-result-tag">
          {content.metadata.tag?.map((tag) => (
            <span key={tag.id}>{tag.title}</span>
          ))}
        </span>
      </a>
    </li>
  );
};

export const SearchResults: React.FC<SearchResultsProps> = (props) => {
  const { tagListResult, productListResult } = useSearchResultsController();
  return (
    <div className="search-results-container">
      <SearchFilter
        selectedProductId={props.selectedProductId}
        selectedTags={props.selectedTags}
        onChangeProduct={props.onChangeProduct}
        onChangeTags={props.onChangeTags}
        tagList={tagListResult.tagList}
        productList={productListResult.productList}
      />
      {props.isLoading ? (
        <InlineSpinner />
      ) : (
        <div className="search-results-box">
          <h2 className="search-results-box-title">{`「${props.query}」の検索結果 (${props.contentsList.length})`}</h2>
          {props.contentsList.length === 0 ? (
            <p>
              <b>{props.query}</b> に一致するページは見つかりませんでした。
            </p>
          ) : (
            <ul className="search-results-item-box">
              {props.contentsList.map((content) => (
                <SearchResultItem
                  key={content.id}
                  content={content}
                  query={props.query}
                />
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
